import axios from "axios";
import { logout } from "../reducers/userReducer";
import store from "../app/store";

export default async function fetchServer({
  method,
  url,
  data,
  headers = {},
  api = "https://spinwheel-xtgv.onrender.com/api",
  onDownloadProgress,
  config,
  ...restOptions
}) {
  try {
    if (!headers?.Authorization) {
      const user = store.getState().user.user;
      let token = user.accessToken || user.agent.token;

      if (token) {
        headers.Authorization = "Bearer " + token;
      } else headers.Authorization = null;
    }
  } catch (ex) {}

  const res = await axios({
    method,
    url: api + url,
    data,
    onDownloadProgress,
    headers,
    ...restOptions,
  }).catch((err) => {
    if (axios.isCancel(err)) {
      return { cancelled: true };
    }
    if (err?.response?.status === 401) {
      store.dispatch(logout());
    }
    if (!err?.response?.status)
      throw new Error(
        err || "Network Error! Please check your network connectivity."
      );

    return err?.response?.data;
  });

  return res;
}

axios.interceptors.request.use((config) => {
  config.metadata = { startTime: new Date() }; // Store the request start time
  return config;
});

axios.interceptors.response.use((response) => {
  const { startTime } = response.config.metadata;
  const elapsedTime = new Date() - startTime; // Calculate the elapsed time
  // const progress = Math.round((elapsedTime / 1000) * 10); // Assuming 10 milliseconds per percentage point
  // response.config.metadata.progress = progress;
  response.duration = elapsedTime;

  return response;
});
